import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DocumentTitle from 'react-document-title';
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { adminRoutes } from 'assets/routes';
import { Container, Header, Loader, Button, List, Input, Modal, Icon, Dropdown, Message, Label, Progress, Checkbox } from 'semantic-ui-react';
import './index.css';
import { logout } from 'store/User';

class Storage extends Component {
  state = {
    loading: false,
    items: [],
    directories: [],
    currentDirectory: "/",
    qrModal: false,
    qrItem: null,
    qrSvg: "",
    qrErrorLevel: "L",
    qrMargin: 1,
    uploadFile: null,
    newDirModal: false,
    newDirName: "",
    renameDirModal: false,
    renameDirPath: "",
    renameDirNewName: "",
    deleteDirModal: false,
    deleteDirPath: "",
    moveFileModal: false,
    moveFileItem: null,
    moveTargetDir: "",
    error: "",
    success: "",
    s3UploadProgress: 0,
    selectedItems: [],
    previewModal: false,
    previewItem: null,
    createItemModal: false,
    createItemName: "",
    s3BrowseModal: false,
    s3BrowseMode: "select",
    s3BrowseItemFor: null,
    s3BrowseItems: [],
    s3BrowseLoading: false,
    s3SearchFilter: "",
    s3CurrentPrefix: "",
    s3SelectedPrefix: "",
    uploadFile: null,
    linkS3Modal: false,
    linkS3Item: null,
    linkS3Key: "",
    attachUrlModal: false,
    attachUrlItem: null,
    attachUrlValue: "",
    attachUrlMime: "",
    detachItem: null,
  };

  componentDidMount() {
    this.fetchItems();
    this.fetchDirectories();
  }

  fetchItems = (directory) => {
    const dir = directory || this.state.currentDirectory;
    this.setState({ loading: true });

    axios
      .get(adminRoutes.storage.getItems(), { params: { directory: dir } })
      .then(response => {
        this.setState({ loading: false, items: response.data.message });
      })
      .catch(error => {
        this.setState({ loading: false });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  fetchDirectories = () => {
    axios
      .get(adminRoutes.storage.getDirectories())
      .then(response => {
        this.setState({ directories: response.data.message });
      })
      .catch(() => {});
  };

  navigateToDir = (dir) => {
    this.setState({ currentDirectory: dir }, () => this.fetchItems());
  };

  navigateToItem = (linkedItem) => {
    const dir = (linkedItem.directory || "/").replace(/\/+$/, "") || "/";
    this.setState({
      s3BrowseModal: false,
      s3BrowseMode: "select",
      s3BrowseItemFor: null,
      uploadFile: null,
      s3CurrentPrefix: "",
      s3SelectedPrefix: "",
      currentDirectory: dir,
    }, () => this.fetchItems());
  };

  handleUploadModal = () => {
    const dir = this.state.currentDirectory === "/" ? "" : this.state.currentDirectory.replace(/^\//, "");
    this.setState({
      s3BrowseModal: true,
      s3BrowseMode: "uploadDir",
      s3BrowseItemFor: null,
      s3BrowseItems: [],
      s3BrowseLoading: true,
      s3SearchFilter: "",
      s3CurrentPrefix: dir,
      s3SelectedPrefix: dir,
      uploadFile: null,
      error: "",
    });
    this.fetchS3Items();
  };

  handleFileSelect = (e) => {
    this.setState({ uploadFile: e.target.files[0] });
  };

  handleUpload = () => {
    const { uploadFile, s3SelectedPrefix } = this.state;
    if (!uploadFile) return;

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("filename", uploadFile.name);
    formData.append("directory", s3SelectedPrefix ? "/" + s3SelectedPrefix : "/");
    formData.append("s3Prefix", s3SelectedPrefix || "");

    this.setState({ s3UploadProgress: 0 });

    axios
      .post(adminRoutes.storage.upload(), formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          const pct = Math.round((e.loaded / e.total) * 100);
          this.setState({ s3UploadProgress: pct });
        },
      })
      .then(() => {
        this.setState({ s3BrowseModal: false, s3BrowseMode: "select", s3BrowseItemFor: null, uploadFile: null, s3UploadProgress: 0, s3CurrentPrefix: "", s3SelectedPrefix: "", success: "Файл загружен" });
        this.fetchItems();
        this.fetchDirectories();
      })
      .catch(error => {
        this.setState({ s3UploadProgress: 0, error: "Ошибка при загрузке" });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleUploadContentModal = (item) => {
    const dir = item.directory === "/" ? "" : item.directory.replace(/^\//, "");
    this.setState({
      s3BrowseModal: true,
      s3BrowseMode: "uploadContent",
      s3BrowseItemFor: item,
      s3BrowseItems: [],
      s3BrowseLoading: true,
      s3SearchFilter: "",
      s3CurrentPrefix: dir,
      s3SelectedPrefix: dir,
      uploadFile: null,
      error: "",
    });
    this.fetchS3Items();
  };

  handleUploadContent = () => {
    const { uploadFile, s3BrowseItemFor, s3SelectedPrefix } = this.state;
    if (!uploadFile || !s3BrowseItemFor) return;

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("filename", uploadFile.name);
    formData.append("directory", s3SelectedPrefix ? "/" + s3SelectedPrefix : "/");
    formData.append("s3Prefix", s3SelectedPrefix || "");

    this.setState({ s3UploadProgress: 0 });

    axios
      .post(adminRoutes.storage.uploadContent(s3BrowseItemFor._id), formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          const pct = Math.round((e.loaded / e.total) * 100);
          this.setState({ s3UploadProgress: pct });
        },
      })
      .then(() => {
        this.setState({ s3BrowseModal: false, s3BrowseMode: "select", s3BrowseItemFor: null, uploadFile: null, s3UploadProgress: 0, s3CurrentPrefix: "", s3SelectedPrefix: "", success: "Контент загружен" });
        this.fetchItems();
      })
      .catch(error => {
        this.setState({ s3UploadProgress: 0, error: "Ошибка при загрузке контента" });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleReplaceModal = (item) => {
    const dir = item.directory === "/" ? "" : item.directory.replace(/^\//, "");
    this.setState({
      s3BrowseModal: true,
      s3BrowseMode: "replace",
      s3BrowseItemFor: item,
      s3BrowseItems: [],
      s3BrowseLoading: true,
      s3SearchFilter: "",
      s3CurrentPrefix: dir,
      s3SelectedPrefix: dir,
      uploadFile: null,
      error: "",
    });
    this.fetchS3Items();
  };

  handleReplace = () => {
    const { uploadFile, s3BrowseItemFor, s3SelectedPrefix } = this.state;
    if (!uploadFile || !s3BrowseItemFor) return;
    if (!window.confirm(`Заменить файл для «${s3BrowseItemFor.name}»? Старый S3-файл будет удалён.`)) return;

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("filename", uploadFile.name);
    formData.append("directory", s3SelectedPrefix ? "/" + s3SelectedPrefix : "/");
    formData.append("s3Prefix", s3SelectedPrefix || "");

    this.setState({ s3UploadProgress: 0 });

    axios
      .post(adminRoutes.storage.replaceFile(s3BrowseItemFor._id), formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          const pct = Math.round((e.loaded / e.total) * 100);
          this.setState({ s3UploadProgress: pct });
        },
      })
      .then(() => {
        this.setState({ s3BrowseModal: false, s3BrowseMode: "select", s3BrowseItemFor: null, uploadFile: null, s3UploadProgress: 0, s3CurrentPrefix: "", s3SelectedPrefix: "", success: "Файл заменён" });
        this.fetchItems();
      })
      .catch(error => {
        this.setState({ s3UploadProgress: 0, error: "Ошибка при замене" });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleDelete = (id) => {
    if (!window.confirm("Удалить запись? S3-файл останется.")) return;

    axios
      .delete(adminRoutes.storage.deleteItem(id))
      .then(() => {
        this.setState({ success: "Запись удалена" });
        this.fetchItems();
      })
      .catch(error => {
        if (error.response && error.response.status === 401) this.props.logout();
        else if (error.response) this.setState({ error: error.response.data.message });
      });
  };

  handleBulkDelete = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) return;
    if (!window.confirm(`Удалить ${selectedItems.length} записей? S3-файлы не пострадают.`)) return;

    axios
      .post(adminRoutes.storage.bulkDelete(), { ids: selectedItems })
      .then(() => {
        this.setState({ selectedItems: [], success: `Удалено ${selectedItems.length} записей` });
        this.fetchItems();
      })
      .catch(error => {
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleSelectAll = (e, { checked }) => {
    const { items } = this.state;
    if (checked) {
      this.setState({ selectedItems: items.map(i => i._id) });
    } else {
      this.setState({ selectedItems: [] });
    }
  };

  handleSelectItem = (id) => {
    this.setState(prev => {
      const sel = prev.selectedItems;
      if (sel.includes(id)) {
        return { selectedItems: sel.filter(i => i !== id) };
      }
      return { selectedItems: [...sel, id] };
    });
  };

  handleS3Delete = (key) => {
    if (!window.confirm(`Удалить файл «${key}» из S3? Записи с QR останутся, но контент будет откреплён.`)) return;

    axios
      .post(adminRoutes.storage.s3Delete(), { keys: [key] })
      .then(response => {
        const { preserved, deleted, errors } = response.data.message;
        let msg = `Удалено из S3: ${deleted.length} записей.`;
        if (preserved.length > 0) msg += ` Сохранено (с QR): ${preserved.length}.`;
        if (errors.length > 0) msg += ` Ошибок: ${errors.length}.`;
        this.setState({ success: msg });
        this.fetchS3Items();
      })
      .catch(error => {
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleS3DeleteDir = (dir) => {
    const { s3BrowseItems } = this.state;
    const keys = s3BrowseItems.filter(o => o.key.startsWith(dir)).map(o => o.key);
    if (keys.length === 0) return;
    if (!window.confirm(`Удалить папку «${dir}» (${keys.length} файлов) из S3? Записи с QR останутся.`)) return;

    axios
      .post(adminRoutes.storage.s3Delete(), { keys })
      .then(response => {
        const { preserved, deleted, errors } = response.data.message;
        let msg = `Удалено из S3: ${deleted.length} записей, ${keys.length} S3-объектов.`;
        if (preserved.length > 0) msg += ` Сохранено (с QR): ${preserved.length}.`;
        if (errors.length > 0) msg += ` Ошибок: ${errors.length}.`;
        this.setState({ success: msg });
        this.fetchS3Items();
      })
      .catch(error => {
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handlePreview = (item) => {
    this.setState({ previewModal: true, previewItem: item });
  };

  handleOpenInNewTab = (item) => {
    const url = `/storage/access/${item.uuid}`;
    const mime = item.mimeType || "";
    const win = window.open("", "_blank");
    if (!win) return;
    if (mime.startsWith("image/")) {
      win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${item.name}</title><style>body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#222}img{max-width:100%;max-height:100vh;object-fit:contain}</style></head><body><img src="${url}" alt="${item.name}"></body></html>`);
    } else if (mime.startsWith("video/")) {
      win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${item.name}</title><style>body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#222}video{max-width:100%;max-height:100vh}</style></head><body><video controls autoplay><source src="${url}" type="${mime}"></video></body></html>`);
    } else if (mime.startsWith("audio/")) {
      win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${item.name}</title><style>body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#222}audio{width:80%}</style></head><body><audio controls autoplay><source src="${url}" type="${mime}"></audio></body></html>`);
    } else if (mime === "application/pdf") {
      win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${item.name}</title><style>body{margin:0;height:100vh}iframe{width:100%;height:100%;border:none}</style></head><body><iframe src="${url}"></iframe></body></html>`);
    } else {
      win.close();
      const a = document.createElement("a");
      a.href = url;
      a.download = item.originalName || item.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    win.document.close();
  };

  getQrParams = () => {
    const { qrErrorLevel, qrMargin } = this.state;
    return `?errorCorrectionLevel=${qrErrorLevel}&margin=${qrMargin}`;
  };

  fetchQrSvg = (item) => {
    const url = adminRoutes.storage.getQr(item._id) + this.getQrParams();
    return axios.get(url, { responseType: "text" });
  };

  handleGenerateQr = (item) => {
    this.setState({ loading: true, qrItem: item, qrSvg: "", qrErrorLevel: "L", qrMargin: 1 });

    axios
      .post(adminRoutes.storage.generateQr(item._id))
      .then(() => this.fetchQrSvg(item))
      .then(response => {
        this.setState({ loading: false, qrModal: true, qrSvg: response.data });
      })
      .catch(error => {
        this.setState({ loading: false });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleShowQr = (item) => {
    this.setState({ loading: true, qrItem: item, qrSvg: "", qrErrorLevel: "L", qrMargin: 1 });

    this.fetchQrSvg(item)
      .then(response => {
        this.setState({ loading: false, qrModal: true, qrSvg: response.data });
      })
      .catch(error => {
        this.setState({ loading: false });
        if (error.response && error.response.status === 401) this.props.logout();
      });
  };

  handleDisableQr = (item) => {
    if (!window.confirm(`Отключить QR для «${item.name}»?`)) return;

    axios
      .post(adminRoutes.storage.disableQr(item._id))
      .then(() => {
        this.setState({ success: "QR отключён" });
        this.fetchItems();
      })
      .catch(error => {
        if (error.response && error.response.status === 401) this.props.logout();
        else if (error.response) this.setState({ error: error.response.data.message });
      });
  };

  handleDownloadQr = (id) => {
    const url = adminRoutes.storage.downloadQr(id) + this.getQrParams();
    axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'image/png' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'qr.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {});
  };

  handleNewDirModal = () => {
    this.setState({ newDirModal: !this.state.newDirModal, newDirName: "", error: "" });
  };

  handleCreateDir = () => {
    const { newDirName, currentDirectory } = this.state;
    if (!newDirName) return;

    const fullPath = currentDirectory === "/" ? `/${newDirName}` : `${currentDirectory}/${newDirName}`;

    axios
      .post(adminRoutes.storage.createDirectory(), { path: fullPath })
      .then(() => {
        this.setState({ newDirModal: false, newDirName: "", success: "Папка создана" });
        this.fetchDirectories();
        this.navigateToDir(fullPath);
      })
      .catch(() => {
        this.setState({ error: "Ошибка при создании папки" });
      });
  };

  handleRenameDirModal = (dir) => {
    const name = dir === "/" ? "" : dir.split("/").pop();
    this.setState({ renameDirModal: true, renameDirPath: dir, renameDirNewName: name, error: "" });
  };

  handleRenameDir = () => {
    const { renameDirPath, renameDirNewName, currentDirectory } = this.state;
    if (!renameDirNewName) return;

    const parentPath = renameDirPath.includes("/") ? renameDirPath.substring(0, renameDirPath.lastIndexOf("/")) || "/" : "/";
    const newPath = parentPath === "/" ? `/${renameDirNewName}` : `${parentPath}/${renameDirNewName}`;

    axios
      .put(adminRoutes.storage.renameDirectory(), { oldPath: renameDirPath, newPath })
      .then(() => {
        this.setState({ renameDirModal: false, success: "Папка переименована" });
        this.fetchDirectories();
        if (currentDirectory === renameDirPath) {
          this.navigateToDir(newPath);
        } else if (currentDirectory.startsWith(renameDirPath + "/")) {
          this.navigateToDir(currentDirectory.replace(renameDirPath, newPath));
        }
      })
      .catch(() => {
        this.setState({ error: "Ошибка при переименовании" });
      });
  };

  handleDeleteDirModal = (dir) => {
    this.setState({ deleteDirModal: true, deleteDirPath: dir, error: "" });
  };

  handleDeleteDir = () => {
    const { deleteDirPath, currentDirectory } = this.state;

    axios
      .delete(adminRoutes.storage.deleteDirectory(), { data: { path: deleteDirPath } })
      .then(response => {
        this.setState({ deleteDirModal: false, success: response.data.message || "Папка удалена" });
        this.fetchDirectories();
        if (currentDirectory === deleteDirPath || currentDirectory.startsWith(deleteDirPath + "/")) {
          this.navigateToDir("/");
        }
      })
      .catch(() => {
        this.setState({ error: "Ошибка при удалении папки" });
      });
  };

  handleMoveFileModal = (item) => {
    this.setState({ moveFileModal: true, moveFileItem: item, moveTargetDir: item.directory || "/", error: "" });
  };

  handleMoveFile = () => {
    const { moveFileItem, moveTargetDir } = this.state;
    if (!moveFileItem) return;

    axios
      .patch(adminRoutes.storage.moveFile(moveFileItem._id), { directory: moveTargetDir })
      .then(() => {
        this.setState({ moveFileModal: false, moveFileItem: null, success: "Файл перемещён" });
        this.fetchItems();
      })
      .catch(() => {
        this.setState({ error: "Ошибка при перемещении" });
      });
  };

  handleCreateItemModal = () => {
    this.setState({ createItemModal: !this.state.createItemModal, createItemName: "", error: "" });
  };

  handleCreateItem = () => {
    const { createItemName, currentDirectory } = this.state;
    if (!createItemName) return;

    axios
      .post(adminRoutes.storage.createItem(), { name: createItemName, directory: currentDirectory })
      .then(() => {
        this.setState({ createItemModal: false, createItemName: "", success: "Запись создана" });
        this.fetchItems();
        this.fetchDirectories();
      })
      .catch(() => {
        this.setState({ error: "Ошибка при создании записи" });
      });
  };

  handleS3BrowseOpen = (item) => {
    this.setState({ s3BrowseModal: true, s3BrowseMode: "select", s3BrowseItemFor: item, s3BrowseItems: [], s3BrowseLoading: true, s3SearchFilter: "", s3CurrentPrefix: "", s3SelectedPrefix: "", uploadFile: null, error: "" });

    this.fetchS3Items();
  };

  fetchS3Items = () => {
    axios
      .get(adminRoutes.storage.browseS3())
      .then(response => {
        this.setState({ s3BrowseLoading: false, s3BrowseItems: response.data.message || [] });
      })
      .catch(() => {
        this.setState({ s3BrowseLoading: false, error: "Не удалось загрузить список S3" });
      });
  };

  handleS3Select = (s3Key) => {
    const { s3BrowseItemFor, s3BrowseMode } = this.state;
    if (!s3BrowseItemFor) return;
    if (s3BrowseMode === "replace" && !window.confirm(`Заменить файл для «${s3BrowseItemFor.name}»?`)) return;

    this.setState({ s3BrowseLoading: true });

    const request = s3BrowseMode === "replace"
      ? axios.post(adminRoutes.storage.replaceFromS3(s3BrowseItemFor._id), { s3Key })
      : axios.post(adminRoutes.storage.linkS3Key(s3BrowseItemFor._id), { s3Key });

    request
      .then(() => {
        this.setState({ s3BrowseModal: false, s3BrowseMode: "select", s3BrowseItemFor: null, s3BrowseItems: [], s3BrowseLoading: false, s3CurrentPrefix: "", s3SelectedPrefix: "", success: s3BrowseMode === "replace" ? "Файл заменён" : "S3-файл привязан" });
        this.fetchItems();
      })
      .catch(() => {
        this.setState({ s3BrowseLoading: false, error: "Ошибка при " + (s3BrowseMode === "replace" ? "замене" : "привязке S3") });
      });
  };

  handleLinkS3Modal = (item) => {
    this.setState({ linkS3Modal: true, linkS3Item: item, linkS3Key: "", error: "" });
  };

  handleLinkS3 = () => {
    const { linkS3Item, linkS3Key } = this.state;
    if (!linkS3Item || !linkS3Key) return;

    axios
      .post(adminRoutes.storage.linkS3Key(linkS3Item._id), { s3Key: linkS3Key })
      .then(() => {
        this.setState({ linkS3Modal: false, linkS3Item: null, linkS3Key: "", success: "S3-ключ привязан" });
        this.fetchItems();
      })
      .catch(() => {
        this.setState({ error: "Ошибка при привязке S3" });
      });
  };

  handleAttachUrlModal = (item) => {
    this.setState({ attachUrlModal: true, attachUrlItem: item, attachUrlValue: "", attachUrlMime: "", error: "" });
  };

  handleAttachUrl = () => {
    const { attachUrlItem, attachUrlValue, attachUrlMime } = this.state;
    if (!attachUrlItem || !attachUrlValue) return;

    axios
      .post(adminRoutes.storage.attachUrl(attachUrlItem._id), { url: attachUrlValue, mimeType: attachUrlMime || undefined })
      .then(() => {
        this.setState({ attachUrlModal: false, attachUrlItem: null, attachUrlValue: "", attachUrlMime: "", success: "URL прикреплён" });
        this.fetchItems();
      })
      .catch(() => {
        this.setState({ error: "Ошибка при прикреплении URL" });
      });
  };

  handleDetachContent = (item) => {
    this.setState({ detachItem: item });
  };

  confirmDetach = () => {
    const { detachItem } = this.state;
    if (!detachItem) return;

    axios
      .post(adminRoutes.storage.detachContent(detachItem._id))
      .then(() => {
        this.setState({ detachItem: null, success: "Контент откреплён" });
        this.fetchItems();
      })
      .catch(() => {
        this.setState({ detachItem: null, error: "Ошибка при откреплении контента" });
      });
  };

  handleSyncS3 = () => {
    this.setState({ loading: true });

    axios
      .post(adminRoutes.storage.syncS3())
      .then(response => {
        const count = response.data.message.created;
        this.setState({ loading: false, success: `Синхронизация завершена. Создано записей: ${count}` });
        this.fetchItems();
        this.fetchDirectories();
      })
      .catch(() => {
        this.setState({ loading: false, error: "Ошибка при синхронизации S3" });
      });
  };

  getContentStatus = (item) => {
    if (item.storageType === "s3") return { label: "S3", color: "blue" };
    if (item.storageType === "local") return { label: "Локально", color: "grey" };
    if (item.storageType === "url") return { label: "URL", color: "teal" };
    return { label: "Нет контента", color: "orange" };
  };

  formatSize = (bytes) => {
    if (!bytes) return "0 B";
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
  };

  getFileIcon = (mimeType) => {
    if (!mimeType) return "file outline";
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    if (mimeType.startsWith("audio/")) return "music";
    if (mimeType.includes("pdf")) return "file pdf";
    if (mimeType.includes("zip") || mimeType.includes("rar")) return "archive";
    return "file";
  };

  isPreviewable = (mimeType) => {
    if (!mimeType) return false;
    return mimeType.startsWith("image/") || mimeType.startsWith("video/") || mimeType.startsWith("audio/") || mimeType === "application/pdf";
  };

  hasContent = (item) => {
    return !!item.storageType;
  };

  renderDirTree = () => {
    const { directories, currentDirectory } = this.state;

    const dirItems = ["/", ...directories.filter(d => d !== "/")].map(dir => {
      const label = dir === "/" ? "Корень" : dir.split("/").pop();
      const indent = dir === "/" ? 0 : dir.split("/").length - 1;

      return (
        <div key={dir} className="admin-storage-dir-item-wrapper">
          <div
            className={`admin-storage-dir-item ${currentDirectory === dir ? "active" : ""}`}
            style={{ paddingLeft: `${12 + indent * 16}px` }}
            onClick={() => this.navigateToDir(dir)}
          >
            <Icon name={dir === "/" ? "home" : "folder"} />
            <span className="admin-storage-dir-label">{label}</span>
            {dir !== "/" && (
              <span className="admin-storage-dir-actions" onClick={e => e.stopPropagation()}>
                <Dropdown icon="ellipsis vertical" className="admin-storage-dir-dropdown">
                  <Dropdown.Menu>
                    <Dropdown.Item icon="pencil" text="Переименовать" onClick={() => this.handleRenameDirModal(dir)} />
                    <Dropdown.Item icon="trash" text="Удалить" onClick={() => this.handleDeleteDirModal(dir)} />
                  </Dropdown.Menu>
                </Dropdown>
              </span>
            )}
          </div>
        </div>
      );
    });

    return (
      <div className="admin-storage-sidebar">
        <div className="admin-storage-sidebar-header">
          <Icon name="folder open" /> Каталоги
        </div>
        <Button className="admin-storage-new-dir-btn" size="small" onClick={this.handleNewDirModal}>
          <Icon name="plus" /> Новая папка
        </Button>
        {dirItems}
      </div>
    );
  };

  renderFileList = () => {
    const { items, currentDirectory, selectedItems } = this.state;
    const anySelected = selectedItems.length > 0;

    return (
      <div className="admin-storage-content">
        <div className="admin-storage-toolbar">
          <span className="admin-storage-path">
            <Icon name="folder" /> {currentDirectory}
          </span>
          <div className="admin-storage-toolbar-actions">
            <Button className="admin-storage-sync-btn" size="tiny" onClick={this.handleSyncS3} title="Сканировать S3 корзину">
              <Icon name="sync" /> Синхр. S3
            </Button>
            {anySelected && (
              <Button negative size="tiny" onClick={this.handleBulkDelete}>
                <Icon name="trash" /> Удалить ({selectedItems.length})
              </Button>
            )}
            <Button className="admin-storage-create-btn" onClick={this.handleCreateItemModal}>
              <Icon name="plus" /> Новая запись
            </Button>
            <Button className="admin-storage-upload-btn" onClick={this.handleUploadModal}>
              <Icon name="upload" /> Загрузить
            </Button>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="admin-storage-empty">
            <Icon name="folder open" size="huge" />
            <p>Папка пуста</p>
          </div>
        ) : (
          <List divided relaxed="very" className="admin-storage-list">
            <List.Item className="admin-storage-list-header">
              <Checkbox
                checked={selectedItems.length === items.length}
                indeterminate={selectedItems.length > 0 && selectedItems.length < items.length}
                onChange={this.handleSelectAll}
              />
              <span className="admin-storage-list-header-label">Выбрать все</span>
            </List.Item>
            {items.map(item => {
              const status = this.getContentStatus(item);
              const checked = selectedItems.includes(item._id);
              return (
                <List.Item key={item._id} className={`admin-storage-list-item ${checked ? "selected" : ""}`}>
                  <Checkbox checked={checked} onChange={() => this.handleSelectItem(item._id)} />
                  <List.Icon name={this.getFileIcon(item.mimeType)} size="large" />
                  <List.Content>
                    <List.Header>{item.name}</List.Header>
                    <List.Description>
                      <Label size="tiny" color={status.color}>{status.label}</Label>
                      {item.mimeType && ` ${this.formatSize(item.size)} · ${item.s3Key ? item.s3Key.split("/").pop() : item.originalName || item.mimeType}`}
                      {item.qrEnabled && " · QR готов"}
                    </List.Description>
                  </List.Content>
                  <div className="admin-storage-actions">
                    {item.qrEnabled ? (
                      <Button icon="qrcode" size="tiny" onClick={() => this.handleShowQr(item)} title="Показать QR" />
                    ) : (
                      <Button icon="qrcode" size="tiny" onClick={() => this.handleGenerateQr(item)} title="Сгенерировать QR" />
                    )}
                    {this.isPreviewable(item.mimeType) && this.hasContent(item) && (
                      <Button icon="eye" size="tiny" onClick={() => this.handlePreview(item)} title="Предпросмотр" />
                    )}
                    <Dropdown icon="ellipsis horizontal" className="admin-storage-item-dropdown" direction="left">
                      <Dropdown.Menu>
                        {!this.hasContent(item) && (
                          <Dropdown.Item icon="cloud upload" text="Загрузить контент" onClick={() => this.handleUploadContentModal(item)} />
                        )}
                        {!this.hasContent(item) && (
                          <Dropdown.Item icon="cloud" text="Выбрать из S3" onClick={() => this.handleS3BrowseOpen(item)} />
                        )}
                        <Dropdown.Item icon="linkify" text="Прикрепить URL" onClick={() => this.handleAttachUrlModal(item)} />
                        {this.hasContent(item) && (
                          <Dropdown.Item icon="exchange" text="Заменить файл" onClick={() => this.handleReplaceModal(item)} />
                        )}
                        <Dropdown.Item icon="move" text="Переместить" onClick={() => this.handleMoveFileModal(item)} />
                        {item.qrEnabled && (
                          <Dropdown.Item icon="cancel" text="Отключить QR" onClick={() => this.handleDisableQr(item)} />
                        )}
                        {this.hasContent(item) && (
                          <Dropdown.Divider />
                        )}
                        {this.hasContent(item) && (
                          <Dropdown.Item icon="unlink" text="Открепить контент" onClick={() => this.handleDetachContent(item)} />
                        )}
                        <Dropdown.Divider />
                        <Dropdown.Item icon="trash" text="Удалить" onClick={() => this.handleDelete(item._id)} />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </List.Item>
              );
            })}
          </List>
        )}
      </div>
    );
  };



  handleQrSettingChange = (key, value) => {
    this.setState({ [key]: value }, () => {
      const { qrItem } = this.state;
      if (qrItem) this.fetchQrSvg(qrItem).then(response => this.setState({ qrSvg: response.data })).catch(() => {});
    });
  };

  renderQrModal = () => {
    const { qrModal, qrItem, qrSvg, qrErrorLevel, qrMargin } = this.state;

    return (
      <Modal open={qrModal} onClose={() => this.setState({ qrModal: false })} size="small">
        <Modal.Header>QR код</Modal.Header>
        <Modal.Content className="admin-storage-qr-content">
          {qrSvg && (
            <div dangerouslySetInnerHTML={{ __html: qrSvg }} className="admin-storage-qr-svg" />
          )}
          {qrItem && (
            <div className="admin-storage-file-info">
              Файл: {qrItem.name}
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          {qrItem && (
            <Button icon="download" content="Скачать PNG" onClick={() => this.handleDownloadQr(qrItem._id)} />
          )}
          <Button onClick={() => this.setState({ qrModal: false })}>Закрыть</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderPreviewModal = () => {
    const { previewModal, previewItem } = this.state;

    if (!previewItem) return null;

    const url = `/storage/access/${previewItem.uuid}`;
    const mime = previewItem.mimeType || "";

    return (
      <Modal open={previewModal} onClose={() => this.setState({ previewModal: false })} size="large">
        <Modal.Header>{previewItem.name}</Modal.Header>
        <Modal.Content className="admin-storage-preview-content">
          {mime.startsWith("image/") ? (
            <img src={url} alt={previewItem.name} className="admin-storage-preview-image" />
          ) : mime.startsWith("video/") ? (
            <video controls className="admin-storage-preview-video">
              <source src={url} type={mime} />
            </video>
          ) : mime.startsWith("audio/") ? (
            <audio controls className="admin-storage-preview-audio">
              <source src={url} type={mime} />
            </audio>
          ) : mime === "application/pdf" ? (
            <iframe src={url} className="admin-storage-preview-pdf" title="pdf" />
          ) : (
            <p>Предпросмотр недоступен</p>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon="external" content="Открыть в новой вкладке" onClick={() => this.handleOpenInNewTab(previewItem)} />
          <Button onClick={() => this.setState({ previewModal: false })}>Закрыть</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderNewDirModal = () => {
    const { newDirModal, newDirName, currentDirectory } = this.state;

    return (
      <Modal open={newDirModal} onClose={this.handleNewDirModal} size="small">
        <Modal.Header>Новая папка</Modal.Header>
        <Modal.Content>
          <p>Создать папку в: <strong>{currentDirectory}</strong></p>
          <Input placeholder="Название папки" value={newDirName} onChange={e => this.setState({ newDirName: e.target.value })} />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleNewDirModal}>Отмена</Button>
          <Button primary onClick={this.handleCreateDir} disabled={!newDirName}>Создать</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderRenameDirModal = () => {
    const { renameDirModal, renameDirPath, renameDirNewName } = this.state;

    return (
      <Modal open={renameDirModal} onClose={() => this.setState({ renameDirModal: false })} size="small">
        <Modal.Header>Переименовать папку</Modal.Header>
        <Modal.Content>
          <p>Текущее название: <strong>{renameDirPath}</strong></p>
          <Input
            placeholder="Новое название"
            value={renameDirNewName}
            onChange={e => this.setState({ renameDirNewName: e.target.value })}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ renameDirModal: false })}>Отмена</Button>
          <Button primary onClick={this.handleRenameDir} disabled={!renameDirNewName}>Переименовать</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderDeleteDirModal = () => {
    const { deleteDirModal, deleteDirPath } = this.state;

    return (
      <Modal open={deleteDirModal} onClose={() => this.setState({ deleteDirModal: false })} size="small">
        <Modal.Header>Удаление папки</Modal.Header>
        <Modal.Content>
          <p><strong>Внимание!</strong> Вы собираетесь удалить папку <strong>{deleteDirPath}</strong></p>
          <p>Будут удалены только записи в базе данных. Файлы в S3 хранилище останутся. Записи с QR сохранятся (контент открепится).</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ deleteDirModal: false })}>Отмена</Button>
          <Button negative onClick={this.handleDeleteDir}>Удалить папку</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderMoveFileModal = () => {
    const { moveFileModal, moveFileItem, moveTargetDir, directories } = this.state;

    const dirOptions = ["/", ...directories.filter(d => d !== "/")].map(d => ({
      key: d, value: d, text: d,
    }));

    return (
      <Modal open={moveFileModal} onClose={() => this.setState({ moveFileModal: false })} size="small">
        <Modal.Header>Переместить файл</Modal.Header>
        <Modal.Content>
          {moveFileItem && (
            <div className="admin-storage-file-info">
              Файл: {moveFileItem.name}
            </div>
          )}
          <Dropdown
            placeholder="Выберите папку"
            fluid
            search
            selection
            options={dirOptions}
            value={moveTargetDir}
            onChange={(e, { value }) => this.setState({ moveTargetDir: value })}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ moveFileModal: false })}>Отмена</Button>
          <Button primary onClick={this.handleMoveFile}>Переместить</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderCreateItemModal = () => {
    const { createItemModal, createItemName, currentDirectory } = this.state;

    return (
      <Modal open={createItemModal} onClose={() => this.setState({ createItemModal: false })} size="small">
        <Modal.Header>Новая запись</Modal.Header>
        <Modal.Content>
          <p>Будет создана запись с UUID, к которой позже можно прикрепить контент.</p>
          <p>Каталог: <strong>{currentDirectory}</strong></p>
          <Input placeholder="Название" value={createItemName} onChange={e => this.setState({ createItemName: e.target.value })} />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ createItemModal: false })}>Отмена</Button>
          <Button primary onClick={this.handleCreateItem} disabled={!createItemName}>Создать</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderS3BrowseModal = () => {
    const {
      s3BrowseModal, s3BrowseMode, s3BrowseItemFor,
      s3BrowseItems, s3BrowseLoading, s3SearchFilter, s3CurrentPrefix,
      s3SelectedPrefix, uploadFile, s3UploadProgress,
    } = this.state;

    const uploading = s3UploadProgress > 0;
    const prefix = s3CurrentPrefix;
    const isSelect = s3BrowseMode === "select";
    const isUploadDir = s3BrowseMode === "uploadDir";
    const isUploadContent = s3BrowseMode === "uploadContent";
    const isReplace = s3BrowseMode === "replace";
    const isUpload = isUploadDir || isUploadContent;
    const isUploadOrReplace = isUpload || isReplace;

    const modalTitle = isUploadDir ? "Загрузка файла"
      : isUploadContent ? "Загрузка контента"
      : isReplace ? "Замена файла"
      : "Выберите файл из S3";

    const headerText = isUploadContent && s3BrowseItemFor
      ? `Контент для: ${s3BrowseItemFor.name}`
      : isReplace && s3BrowseItemFor
        ? `Замена файла: ${s3BrowseItemFor.name} (QR не изменится)`
      : isUploadDir
        ? "Выберите папку и файл для загрузки"
      : null;

    const closeModal = () => this.setState({
      s3BrowseModal: false, s3BrowseMode: "select", s3BrowseItemFor: null,
      s3CurrentPrefix: "", s3SelectedPrefix: "", uploadFile: null, s3UploadProgress: 0,
    });

    return (
      <Modal open={s3BrowseModal} onClose={uploading ? undefined : closeModal} size="large">
        <Modal.Header>{modalTitle}</Modal.Header>
        <Modal.Content>
          {headerText && <p style={{ marginBottom: "0.75em" }}>{headerText}</p>}

          {uploading ? (
            <div className="admin-storage-upload-progress">
              <p>Загрузка <strong>{uploadFile ? uploadFile.name : ''}</strong>...</p>
              <Progress percent={s3UploadProgress} progress indicating size="medium" />
            </div>
          ) : (
            <>
              {isUploadOrReplace && (
                <div className="admin-storage-s3-upload-target">
                  <Label color="teal">
                    <Icon name="folder open" />
                    Папка: {s3SelectedPrefix ? "/" + s3SelectedPrefix : "/"}
                  </Label>
                </div>
              )}

              {this.renderS3Tree()}

              {isUploadOrReplace && (
                <div className="admin-storage-s3-file-picker">
                  <input type="file" onChange={this.handleFileSelect} />
                  {uploadFile && (
                    <div className="admin-storage-file-info">
                      {uploadFile.name} ({this.formatSize(uploadFile.size)})
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          {uploading ? null : (
            <>
              <Button onClick={closeModal}>Отмена</Button>
              {isUploadDir && (
                <Button primary onClick={this.handleUpload} disabled={!uploadFile}>
                  Загрузить
                </Button>
              )}
              {isUploadContent && (
                <Button primary onClick={this.handleUploadContent} disabled={!uploadFile}>
                  Загрузить контент
                </Button>
              )}
              {isReplace && (
                <Button primary onClick={this.handleReplace} disabled={!uploadFile}>
                  Заменить
                </Button>
              )}
            </>
          )}
        </Modal.Actions>
      </Modal>
    );
  };

  renderS3Tree = () => {
    const { s3BrowseItems, s3BrowseLoading, s3SearchFilter, s3CurrentPrefix, s3BrowseMode } = this.state;
    const isSelect = s3BrowseMode === "select";
    const isReplace = s3BrowseMode === "replace";
    const prefix = s3CurrentPrefix;

    let items;
    if (s3SearchFilter) {
      items = s3BrowseItems.filter(o => o.name.toLowerCase().includes(s3SearchFilter.toLowerCase()));
    } else if (prefix) {
      items = s3BrowseItems.filter(o => o.key.startsWith(prefix) && o.key !== prefix);
    } else {
      items = s3BrowseItems;
    }

    const dirs = new Set();
    const files = [];
    const prefixParts = prefix ? prefix.split("/").filter(Boolean) : [];

    for (const obj of items) {
      const rest = prefix ? obj.key.substring(prefix.length) : obj.key;
      const parts = rest.split("/").filter(Boolean);
      if (parts.length === 0) continue;

      if (parts.length > 1 || (parts.length === 1 && obj.key.endsWith("/") && !s3SearchFilter)) {
        dirs.add(prefix + parts[0] + "/");
      }
      if (parts.length === 1 && !obj.key.endsWith("/")) {
        files.push(obj);
      }
    }

    const sortedDirs = Array.from(dirs).sort();
    const sortedFiles = files.sort((a, b) => a.name.localeCompare(b.name));

    const getBreadcrumb = () => {
      const crumbs = [{ label: "Корень", value: "" }];
      let path = "";
      for (const part of prefixParts) {
        path += part + "/";
        crumbs.push({ label: part, value: path });
      }
      return crumbs;
    };

    return (
      <>
        <Input
          icon="search"
          placeholder="Поиск по всем файлам..."
          value={s3SearchFilter}
          onChange={e => this.setState({ s3SearchFilter: e.target.value, s3CurrentPrefix: "" })}
          fluid
          className="admin-storage-s3-search"
        />

        <div className="admin-storage-s3-breadcrumb">
          {!s3SearchFilter && getBreadcrumb().map((crumb, i) => (
            <span key={crumb.value}>
              {i > 0 && <Icon name="chevron right" size="small" />}
              <span
                className={`admin-storage-s3-crumb ${i === getBreadcrumb().length - 1 ? "active" : ""}`}
                onClick={() => this.setState({ s3CurrentPrefix: crumb.value, s3SelectedPrefix: crumb.value })}
              >
                {crumb.label}
              </span>
            </span>
          ))}
        </div>

        <div className="admin-storage-s3-list">
          {s3BrowseLoading ? (
            <Loader active inline="centered" />
          ) : s3SearchFilter && items.length === 0 ? (
            <p className="admin-storage-s3-empty">Ничего не найдено</p>
          ) : !s3SearchFilter && sortedDirs.length === 0 && sortedFiles.length === 0 && prefix ? (
            <p className="admin-storage-s3-empty">В этой папке нет файлов</p>
          ) : !s3SearchFilter && sortedDirs.length === 0 && sortedFiles.length === 0 ? (
            <p className="admin-storage-s3-empty">Нет файлов в S3</p>
          ) : (
                <List divided className="admin-storage-s3-items">
                  {!s3SearchFilter && sortedDirs.map(dir => {
                    const dirName = dir.replace(prefix, "").replace("/", "");
                    const fileCount = s3BrowseItems.filter(o => o.key.startsWith(dir) && !o.key.endsWith("/")).length;
                    return (
                      <List.Item
                        key={dir}
                        className="admin-storage-s3-dir-item"
                        onClick={() => this.setState({ s3CurrentPrefix: dir, s3SelectedPrefix: dir })}
                      >
                        <List.Icon name="folder" color="olive" />
                        <List.Content>
                          <List.Header>{dirName}</List.Header>
                          <List.Description>{fileCount} файлов</List.Description>
                        </List.Content>
                        <Button
                          size="mini"
                          icon="trash"
                          color="red"
                          className="admin-storage-s3-del-btn"
                          onClick={e => { e.stopPropagation(); this.handleS3DeleteDir(dir); }}
                          title="Удалить папку"
                        />
                        <Icon name="chevron right" />
                      </List.Item>
                    );
                  })}
                  {(s3SearchFilter ? items : sortedFiles).map(obj => {
                    const canSelect = (isSelect || isReplace) && !obj.linked;
                    return (
                      <List.Item key={obj.key}
                        className={`admin-storage-s3-item ${obj.linked ? "linked" : ""}`}
                        onClick={() => canSelect && this.handleS3Select(obj.key)}
                      >
                        <List.Icon name={obj.linked ? "check circle" : "file"} color={obj.linked ? "green" : undefined} />
                        <List.Content>
                          <List.Header>
                            {obj.name}
                            {obj.linked && <Label size="mini" color="green">Привязан</Label>}
                          </List.Header>
                          <List.Description>
                            {this.formatSize(obj.size)}
                            {obj.linked && obj.linkedItems && obj.linkedItems.map(li => (
                              <div key={li.id} className="admin-storage-s3-linked-item" title={li.uuid}>
                                <Icon name="linkify" size="tiny" /> {li.name}
                                <Button
                                  size="mini"
                                  compact
                                  onClick={e => { e.stopPropagation(); this.navigateToItem(li); }}
                                  style={{ marginLeft: 6 }}
                                >
                                  Найти
                                </Button>
                              </div>
                            ))}
                          </List.Description>
                        </List.Content>
                        <div className="admin-storage-s3-item-actions">
                          {canSelect && <Button size="tiny" primary>{isReplace ? "Заменить" : "Выбрать"}</Button>}
                          <Button
                            size="mini"
                            icon="trash"
                            color="red"
                            className="admin-storage-s3-del-btn"
                            onClick={e => { e.stopPropagation(); this.handleS3Delete(obj.key); }}
                            title="Удалить из S3"
                          />
                        </div>
                      </List.Item>
                    );
                  })}
            </List>
          )}
        </div>
      </>
    );
  };

  renderLinkS3Modal = () => {
    const { linkS3Modal, linkS3Item, linkS3Key } = this.state;

    return (
      <Modal open={linkS3Modal} onClose={() => this.setState({ linkS3Modal: false })} size="small">
        <Modal.Header>Привязка S3-ключа</Modal.Header>
        <Modal.Content>
          {linkS3Item && (
            <p>Запись: <strong>{linkS3Item.name}</strong></p>
          )}
          <p>Укажите путь к объекту в S3 (например <code>storage/abc123-file.mp4</code>). Система получит метаданные из корзины.</p>
          <Input placeholder="S3 Key" value={linkS3Key} onChange={e => this.setState({ linkS3Key: e.target.value })} />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ linkS3Modal: false })}>Отмена</Button>
          <Button primary onClick={this.handleLinkS3} disabled={!linkS3Key}>Привязать</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderAttachUrlModal = () => {
    const { attachUrlModal, attachUrlItem, attachUrlValue, attachUrlMime } = this.state;

    return (
      <Modal open={attachUrlModal} onClose={() => this.setState({ attachUrlModal: false })} size="small">
        <Modal.Header>Прикрепление URL</Modal.Header>
        <Modal.Content>
          {attachUrlItem && (
            <p>Запись: <strong>{attachUrlItem.name}</strong></p>
          )}
          <div className="admin-storage-form-group">
            <label>URL контента</label>
            <Input placeholder="https://..." value={attachUrlValue} onChange={e => this.setState({ attachUrlValue: e.target.value })} />
          </div>
          <div className="admin-storage-form-group">
            <label>MIME-тип (опционально)</label>
            <Input placeholder="video/mp4" value={attachUrlMime} onChange={e => this.setState({ attachUrlMime: e.target.value })} />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ attachUrlModal: false })}>Отмена</Button>
          <Button primary onClick={this.handleAttachUrl} disabled={!attachUrlValue}>Прикрепить</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  renderDetachModal = () => {
    const { detachItem } = this.state;

    return (
      <Modal open={!!detachItem} onClose={() => this.setState({ detachItem: null })} size="small">
        <Modal.Header>Открепление контента</Modal.Header>
        <Modal.Content>
          {detachItem && (
            <>
              <p>Вы собираетесь открепить контент от записи <strong>{detachItem.name}</strong>.</p>
              <p>Запись, QR-код и S3-файл останутся.</p>
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ detachItem: null })}>Отмена</Button>
          <Button negative onClick={this.confirmDetach}>Открепить контент</Button>
        </Modal.Actions>
      </Modal>
    );
  };

  render() {
    const { t } = this.props;
    const { loading, error, success } = this.state;

    return (
      <DocumentTitle title={t("admin.storage.title")}>
        <div className="admin-storage-wrapper">
          {loading && <Loader active size="large" />}

          {success && (
            <Message positive onDismiss={() => this.setState({ success: "" })}>
              <Message.Header>{success}</Message.Header>
            </Message>
          )}
          {error && (
            <Message negative onDismiss={() => this.setState({ error: "" })}>
              <Message.Header>{error}</Message.Header>
            </Message>
          )}

          <Header size="large" textAlign="center" className="admin-storage-header">
            {t("admin.storage.title")}
          </Header>

          <div className="admin-storage-layout">
            {this.renderDirTree()}
            {this.renderFileList()}
          </div>

          {this.renderQrModal()}
          {this.renderPreviewModal()}
          {this.renderNewDirModal()}
          {this.renderRenameDirModal()}
          {this.renderDeleteDirModal()}
          {this.renderMoveFileModal()}
          {this.renderCreateItemModal()}
          {this.renderS3BrowseModal()}
          {this.renderLinkS3Modal()}
          {this.renderAttachUrlModal()}
          {this.renderDetachModal()}
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(Storage);
